import Vue from "vue";
import { getNewUnreadMessage } from "./index";

export default Vue.observable({
    clickNotClose: true,
    isLeftSidebarActive: true,
    isMessageContentActive: false,
    newChatUnread: [],
    newPM: [],
    newWebboardReply: [],
    selectedPanel: 0,
    panels: ['pm', 'chat', 'webboard'],
    currentMessage: null,
    currentTopic: null,
    currentViewingMessages: [],
    currentViewingMessageCursor: 0,
    currentViewingMessageType: "pm",
    messagePool: {
      pm: [],
      webboard: [],
      chat: []
    },
    activeListType: "recent",
    unread: {
      pm: getNewUnreadMessage("pm"),
      chat: getNewUnreadMessage("chat"),
      webboard: getNewUnreadMessage("webboard"),
    }
  });
